var HomeCtrl = function HomeCtrl() {};

export default HomeCtrl;